import { render, staticRenderFns } from "./BotoesEnvio.vue?vue&type=template&id=b240043c&scoped=true"
import script from "./BotoesEnvio.vue?vue&type=script&lang=js"
export * from "./BotoesEnvio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b240043c",
  null
  
)

export default component.exports